import {getWindowScrollTop} from '@opten/dom/get-window-scroll-top';
import {parseCssUnit} from '@opten/number/parse-css-unit';

import { isPad } from './detection';

// todo: @opten/typings?

export function lockScrollbar(
    callback: () => void,
    bodyElement: HTMLElement = document.body
) {
    if (!isPad()) {
        callback();
        return;
    }

    // preserve the current scrolling because `--navbar--expanded`
    // fixes the body, so iOS doesn't scroll in the background!
    const scroll = getWindowScrollTop();

    if (scroll >= 0) {
        requestAnimationFrame(() => {
            bodyElement.style.top = `${clampScroll(scroll)}px`;

            // todo: cache old values?
            document.body.style.height = '100%';
            document.documentElement.style.height = '100%';

            bodyElement.style.position = 'fixed';
            bodyElement.style.width = '100%';
            bodyElement.style.height = '100%';
            bodyElement.style.overflow = 'hidden';

            // some weird behaviour in iOS if we set the element fixed
            // the navbar closes immediately, so we have a timeout...
            setTimeout(() => callback(), 150);
        });
    }
}

export function unlockScrollbar(bodyElement: HTMLElement = document.body, forceUnlock = false) {
    if (!isPad() && forceUnlock === false) {
        return;
    }

    // preserve the cached scroll, so we can scroll
    // back to this state.
    const scroll = clampScroll(parseCssUnit(bodyElement.style.top));
    const paddingTop = parseCssUnit(bodyElement.style.paddingTop);
    bodyElement.style.top = null;

    // todo: reset old values?
    bodyElement.style.position = null;
    bodyElement.style.width = null;
    bodyElement.style.height = null;
    bodyElement.style.overflow = null;
    bodyElement.removeAttribute('style');
    bodyElement.style.paddingTop = paddingTop + "px";


    if (scroll >= 0) {
        scrollTo(0, scroll);
    }
}

export function getStickyOffset() {
    const elements: Array<HTMLElement> = [];

    // todo: better way?
    const header = document.getElementsByClassName(
        'js-header'
    )[0] as HTMLElement;
    // const cookieConsent = document.getElementsByClassName(
    //     'js-cookie-consent'
    // )[0] as HTMLElement;

    if (header) {
        elements.push(header);
    }
    // if (cookieConsent) {
    //     elements.push(cookieConsent);
    // }

    return Math.round(
        elements
            .map(o => o.getBoundingClientRect().height)
            .reduce((pv, cv) => pv + cv, 0)
    );
}

function clampScroll(scroll: number) {
    return scroll === 0 ? scroll : scroll * -1;
}
